var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonTooltip',{staticClass:"zoho-icon",attrs:{"icon":"","x-small":"","color":"primary","target":"_blank","disabled":!_vm.zohoId,"href":_vm.href,"tooltip-text":"Click to open in Zoho"}},[_c('ESvgIcon',{attrs:{"icon":"zoho-crm","color":_vm.color || _vm.defaultColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }